import { z } from 'zod/v4'

export const stripeBindCreditCardResponseSchema = z.object({
  payment_provider_info: z.object({
    stripe_intent_client_secret: z.string(),
  }),
})
